// extracted by mini-css-extract-plugin
module.exports = {"root":"PackageBadges_root__1KT-E","badgeWrapper":"PackageBadges_badgeWrapper__3_0FC","icon":"PackageBadges_icon__15D5z","infoSpan":"PackageBadges_infoSpan__1onKV"};